<template>
  <f7-page>
    <f7-navbar :title="$tc('label.user', 2)" :back-link="$t('action.back')">
      <f7-nav-right>
        <f7-link v-if="hasValidBilling" icon-only icon-ios="f7:plus" icon-md="material:add"
                 @click="popupOpened = true"/>
        <f7-link v-else @click="showWarning" icon-only icon-ios="f7:plus" icon-md="material:add"/>
      </f7-nav-right>
    </f7-navbar>
    <f7-list v-if="invitations.length > 0">
      <f7-list-group>
        <f7-list-item :title="$t('title.invitedUsers')" group-title></f7-list-item>
        <f7-list-item v-for="invitation in invitations" :key="invitation.email" :title="invitation.email"
                      :footer="$t('title.invitedOn', {date: toDateTime(invitation.invited)})">
          <div slot="after">
            <f7-button small @click="resendInvite(invitation)">Resend</f7-button>
            <f7-button small @click="cancelInvite(invitation)" color="pink">Cancel</f7-button>
          </div>
        </f7-list-item>
      </f7-list-group>
    </f7-list>
    <f7-block v-else-if="myTeam.length === 0">
      There are no users yet. Tap + to send invitations to your team members.
    </f7-block>
    <f7-list v-if="myTeam.length > 0">
      <f7-list-item title="Total on all cards" :after="cardsTotal"/>
    </f7-list>
    <f7-list contacts-list>
      <f7-list-group v-for="letter in titleLetters" :key="letter">
        <f7-list-item :title="letter" group-title/>
        <f7-list-item v-for="user in usersStartWith(letter)" :key="user.id" :link="`${links.user}/${user.id}`"
                      :title="user | userName" :after="moneyOnCard(user)"/>
      </f7-list-group>
    </f7-list>
    <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="popupOpened = false">
      <f7-page>
        <f7-navbar :title="$t('title.inviteUsers')" text-color="white">
          <f7-nav-right>
            <f7-link popup-close>{{$t('action.close')}}</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-list form ref="form">
          <f7-list-item v-for="(invitation, i) in newInvitations" :key="i">
            <f7-input type="email"
                      :value="invitation"
                      :placeholder="$t('placeholder.enterEmail')"
                      validate
                      @input="onInput(i, $event.target.value)"
                      :required="i === 0 || i < newInvitations.length-1"
                      :error-message="$t('validation.email')"
                      clear-button @input:clear="clearInput(i)"
                      :label="$t('label.email') + ` #${i+1}`"
            />
          </f7-list-item>
        </f7-list>
        <f7-block>
          <f7-button fill large @click="inviteUsers">{{$t('action.inviteUsers')}}</f7-button>
        </f7-block>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>

<script>
  import api from 'aio-api'
  import helpers from '@/utils/helpers'

  export default {
    name: 'users-list',
    computed: {
      cardsTotal () {
        const total = this.myTeam.filter(u => u.cardBalance).reduce((sum, user) => sum + user.cardBalance, 0)
        return this.formatMoney('GBP', total)
      },
      titleLetters () {
        return this.myTeam.map(u => u.firstName.charAt(0)).filter((value, index, self) => self.indexOf(value) === index)
      }
    },
    data () {
      return {
        newInvitations: [''],
        popupOpened: false
      }
    },
    async created () {
      this.$store.dispatch('fetchTeam')
      this.$store.dispatch('fetchInvitations')
    },
    methods: {
      clearInput (i) {
        if (i < this.newInvitations.length - 1) this.newInvitations.splice(i, 1)
      },
      async inviteUsers () {
        if (this.isFormValid()) {
          try {
            await api.postUserInvitations(this.newInvitations.filter(e => e))
            this.newInvitations = ['']
            this.$store.dispatch('fetchInvitations')
            this.popupOpened = false
          } catch (error) {
            //TODO: i18n (server messages)
            this.$f7.dialog.alert(error.response.data, '')
          }
        }
      },
      moneyOnCard (user) {
        if (user.hasCard) return this.formatMoney('GBP', user.cardBalance)
        else return ''
      },
      async cancelInvite (invite) {
        this.$f7.dialog.confirm(`Cancel invite to ${invite.email}?`, '', async () => {
          await api.cancelInvite(invite.userRegId)
          this.$store.dispatch('fetchInvitations')
        })
      },
      async resendInvite (invite) {
        this.$f7.dialog.confirm(`Resend invite to ${invite.email}?`, '', async () => {
          await api.resendInvite(invite.userRegId)
          this.$f7.dialog.alert("Invitation resent")
        })
      },
      isFormValid () {
        return this.$refs.form.$el.checkValidity() && !!this.newInvitations[0]
      },
      onInput (i, val) {
        this.newInvitations.splice(i, 1, val)
        if (i === this.newInvitations.length - 1 && this.isFormValid()) this.newInvitations.push('')
      },
      usersStartWith (letter) {
        return this.myTeam.filter(u => u.firstName.startsWith(letter))
      },
      showWarning () {
        this.$f7.dialog.alert(this.$t('dialog.paymentDetails'), '', () => {
          this.$f7.view.main.router.navigate(this.links.company)
        })
      }
    },
    mixins: [helpers]
  }
</script>

<style scoped>
  .ios .item-input-with-error-message .item-input-wrap /deep/ input {
    color: #000;
  }
</style>
